import { Tools } from "src/app/utilities/general-tools";

export class EmisionVidaForm {
    public grupoEstructuraID: number = 10;
    public clienteID: number = 457;
    public direccionClienteID: number = 452;
    public nueva: boolean = true;
    public noPoliza: string = '';
    public monedaID: number = 1;
    public formaPagoID: number = 1;
    public concepto: string = "Gastos Funerarios + Beneficios";
    public fecVigDe: string = Tools.getFormatDate({ date: new Date(), formater: 'yyyy-MM-dd' });
    public fecVigA: string = Tools.getFormatDate({ date: new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate()), formater: 'yyyy-MM-dd' });
    public fecEmision: string = Tools.getFormatDate({ date: new Date(), formater: 'yyyy-MM-dd' });
    public frecuenciaPago: string = "CONTADO";
    public status: string = "Vigente";
    public polizaVida: PolizaVidaForm = new PolizaVidaForm();
    public polizaPrima: PolizaPrimas = new PolizaPrimas();
    public polizaRecibo: PolizaRecibo[] = [];
    public beneficiarios: BeneficiarioVidaForm[] = [];
    public polizaSalud: PolizaSaludForm = new PolizaSaludForm();
    public polizaPaquete: PolizaPaqueteForm[] = [];
}

export class PolizaVidaForm {
    public tipo: number = 0;
    public retiro: number = 0;
    public aportaciones: number = 0;
    public plazo = 0;
    public plazoPago: number = 0;
}

export class BeneficiarioVidaForm {
    public nombres: string = '';
    public apPat: string = '';
    public apMat: string = '';
    public fecNacimiento: string = '';
    public sexo: string = 'MASCULINO';
    public correo: string = '';
    public telefono: string = '';
    public parentesco: string = '';
    public fechaStr: string = '';
}

export class PolizaPrimas {
    public primaNeta: number = 0;
    public derecho: number = 0;
    public recargo: number = 0;
    public iva: number = 0;
    public ajuste1: number = 0;
    public ajuste2: number = 0;
    public total: number = 0;
    public comision: number = 0;
}

export class PolizaRecibo {
    public prima: number = 0;
    public derecho: number = 0;
    public recargo: number = 0;
    public iva: number = 0;
    public ajuste1: number = 0;
    public ajuste2: number = 0;
    public cargoExtra: number = 0;
    public total: number = 0;
    public comision: number = 0;
    public serie: number = 1;
    public totalSerie: number = 1;
    public fecVigDe: string = Tools.getFormatDate({ date: new Date(), formater: 'yyyy-MM-dd' });
    public fecVigA: string = Tools.getFormatDate({ date: new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate()), formater: 'yyyy-MM-dd' });
    public fecVence: string = Tools.getFormatDate({ date: new Date(), formater: 'yyyy-MM-dd' });
    public status: string = "pendiente";
}

export class PolizaSaludForm {
    public municipioID: number = 0;
    public cpID: number = 0;
    public colonia: string = "";
    public calle: string = "";
    public aseguradoPolizaForm: AseguradoPolizaForm[] = [];

}


export class AseguradoPolizaForm {
    public nombres: string = "";
    public apellidoPaterno: string = "";
    public apellidoMaterno: string = "";
    public fechaNacimiento: string = "";
    public fechaAntiguedad: string = Tools.getFormatDate({ date: new Date(), formater: 'yyyy-MM-dd' });
    public sexo: boolean = true;
    public certificado: string = "1";
}

export class PolizaPaqueteForm {
    public paqueteID: number = 379;
    public noPaquete: number = 0;
    public coberturas: CoberturasForm[] = [];

}

export class CoberturasForm {
    public coberturaID: number = 0;
    public noPaquete: number = 0;
    public valor: string = "Suma asegurada fija";
    public descripcion: string = "Fallecimiento";
    public prima: number = 0;
    public deducible: number = 0;
}
